import { render, staticRenderFns } from "./BatchMovementTable.vue?vue&type=template&id=66136bdd&scoped=true"
import script from "./BatchMovementTable.vue?vue&type=script&lang=js"
export * from "./BatchMovementTable.vue?vue&type=script&lang=js"
import style0 from "./BatchMovementTable.vue?vue&type=style&index=0&id=66136bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66136bdd",
  null
  
)

export default component.exports